export default [
	{
		handle: { crumb: () => 'Planning général' },
		path: '/website_entertainments/:websiteEntertainmentId/planning_places/:mode',
		lazy: async () => {
			const Module = await import('../pages/Planning/PlanningPlacesPage');
			return { Component: Module.default  };
		},
	},
];
